import React from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import image from '../../assets/images/40635.svg';
import './styles.scss';
import { texts } from '../../config';
import { Alert } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useToast } from '../../context/ToastContext';
import { useContextGlobal } from '../../context/ContextGlobal';
import api from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import { handleExceptionMessage } from '../../util/handleExceptionAxios';
import { message } from '../../util/handleMessages';

const VerifyEmail: React.FC = () => {
    const history = useHistory();
    const { addToast } = useToast();
    const { user, signOut } = useAuth();
    const { setOpenLoading, openLoading } = useContextGlobal();

    React.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const id = params.get('id');
        if (user?.sub && user?.sub !== id) {
            signOut();
        }
    }, [signOut, user]);

    const submit = async () => {
        setOpenLoading(true);

        try {
            const params = new URLSearchParams(window.location.search);
            const token = params.get('token');
            const id = params.get('id');

            let config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            await api.patch(
                `users/verify-email/${id}`,
                {
                    verifiedEmail: true,
                },
                config,
            );

            setTimeout(() => {
                history.push('/');
            }, 100);

            setOpenLoading(false);
        } catch (error) {
            setOpenLoading(false);

            const { messageResponse, typeFeedback } =
                handleExceptionMessage(error);
            addToast({
                type: typeFeedback,
                title: message.error.save,
                description: messageResponse,
            });
        }
    };

    return (
        <div className="container">
            <div className="main-container">
                {/* <CssBaseline /> */}
                <div className="main">
                    <Avatar sx={{ bgcolor: 'secondary.main' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        GESSIS
                    </Typography>
                    <br />
                    <div className="verify-header">
                        <h2>{texts.nameSystem}</h2>
                        <h6>{texts.info}</h6>
                        <img src={image} alt="Gessis" />
                    </div>
                    <Alert
                        severity="info"
                        sx={{
                            borderRadius: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center',
                            maxWidth: 420,
                            width: '100%',
                        }}>
                        Clique no botão para confirmar a verificação do seu
                        email
                    </Alert>
                    <Button
                        fullWidth
                        size="large"
                        variant="contained"
                        sx={{ mt: 3, mb: 2, py: 1.25, maxWidth: 420 }}
                        disabled={openLoading}
                        onClick={() => submit()}>
                        Verificar
                    </Button>
                </div>
            </div>
            <footer className="footer" style={{}}>
                <Typography variant="body2" color="textPrimary" align="center">
                    {`Copyright © ${texts.nameSystem} `}
                    {new Date().getFullYear()}
                    {'.'}
                </Typography>
            </footer>
        </div>
    );
};

export default VerifyEmail;
